import { APIErrorType } from './ErrorHandler.type';

export const resolveAPIErrorMessage = (
  error: APIErrorType,
  customMessage = 'Apologies! An error has occurred. Please try loading this page after some time.',
): string | null => {
  if (!error) {
    return null;
  }
  if (typeof error === 'string' && error.startsWith('HTTP Error: 500')) {
    return customMessage;
  }

  if (typeof error === 'string') {
    return error;
  }

  if (
    error?.response?.status === 403 ||
    error?.status === 403 ||
    error?.error?.response?.status === 403
  ) {
    return 'You do not have permission to access this content.';
  }

  if (error?.response?.data?.message) {
    return error.response.data.message;
  }

  if (error?.message && error.message !== 'Network Error') {
    return error.message;
  }

  if (error?.data?.message) {
    return error.data.message;
  }

  const data = error?.response?.data ?? error?.data;
  if (data) {
    if (typeof data === 'string') return data;
    if (typeof data.error === 'string') return data.error;
    if (typeof data.detail === 'string') return data.detail;
    if (typeof data.errorMessage === 'string') return data.errorMessage;

    if (Array.isArray(data.errors) && data.errors.length > 0) {
      const first = data.errors[0];
      return typeof first === 'string' ? first : first?.message ?? first?.msg ?? String(first);
    }

    if (typeof data.msg === 'string') return data.msg;
  }

  if (error?.response?.statusText) {
    return error.response.statusText;
  }

  return customMessage;
};
